module.exports = __webpack_public_path__ + "cb6a919a91f5d2ad60099f13d92a82be.svg";